export interface AnalyticsConfiguration_GTM {
  enabled?: boolean;
  gtmId?: string;
}

export const AnalyticsConfiguration_GTM_Graphql_Request_Fragment = `
  enabled
  gtmId
`;
